let activity = {
  state: {

  },
  mutations: {
    closeAct(){
      state = {};
      sessionStorage.removeItem('activity')
    },
    openAct(state,act){
      for(let key in act){
        state[key] = act[key]
      }
      sessionStorage.setItem('activity',JSON.stringify(state))
    },
  }
}

let data = sessionStorage.getItem('activity')?JSON.parse(sessionStorage.getItem('activity')):{}
for(let key in data){
	activity.state[key] = data[key]
}

export default activity


// WEBPACK FOOTER //
// ./src/store/activity/index.js